export enum BtnTypesEnum {
  BUTTON = "button",
  RESET = "reset",
  SUBMIT = "submit",
}

export enum BtnSizesEnum {
  DEFAULT = "default",
  X_SMALL = "xsmall",
  SMALL = "small",
  LARGE = "large",
}

export enum BtnVariantsEnum {
  DEFAULT = "default",
  TRANSPARENT = "transparent",
  LINK = "link",
  DANGER = "danger",
}
